import {Typography} from '@mui/material';
import {Dialog, DialogContent, Stack} from '@mui/material';
import {AppButton, AppIconButton} from 'components/buttons';
import {PopupTransition} from 'components/Theme';
import {CloseSquare} from 'iconsax-react';
import React from 'react';

interface Props {
    open: boolean;
    onDiscardClickHandler: () => void;
    onCancelClickHandler: () => void;
    onConfirmClickHanlder: () => void;
}

export const AlertItemClose: React.FC<Props> = ({
    onDiscardClickHandler,
    onCancelClickHandler,
    onConfirmClickHanlder,
    open,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onDiscardClickHandler}
            TransitionComponent={PopupTransition}
            keepMounted
            fullWidth
            maxWidth="xs"
            aria-labelledby="item-close-title"
            aria-describedby="item-close-description"
        >
            <DialogContent sx={{p: 3, position: 'relative'}}>
                {/* Close Button */}
                <AppIconButton
                    color="inherit"
                    onClick={onCancelClickHandler}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: 'grey.600',
                    }}
                >
                    <CloseSquare size={24} variant="Outline" />
                </AppIconButton>

                {/* Content */}
                <Stack spacing={2} alignItems="center">
                    <Typography variant="h5" fontWeight="bold">
                        Save Changes
                    </Typography>
                    <Typography variant="body1" color="text.secondary" textAlign="center">
                        Do you want to save the changes?
                    </Typography>

                    {/* Action Buttons */}
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <AppButton
                            fullWidth
                            onClick={onDiscardClickHandler}
                            color="secondary"
                            variant="outlined"
                            size="small"
                            sx={{textTransform: 'none', py: 1}}
                        >
                            Discard
                        </AppButton>
                        <AppButton
                            fullWidth
                            size="small"
                            color="primary"
                            variant="contained"
                            onClick={onConfirmClickHanlder}
                            autoFocus
                            sx={{textTransform: 'none', py: 1}}
                        >
                            Save
                        </AppButton>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default AlertItemClose;
